import React, { useEffect, useState } from 'react';
import { getGeneralSettings } from '../../lib/reportStudioApi';
import { useClubIdentity } from '../../lib/useClubIdentity';
import ReportPreviewMock from './ReportPreviewMock';

export default function LivePreviewSection() {
  const identity = useClubIdentity();
  const [settings, setSettings] = useState(null);
  useEffect(() => { getGeneralSettings().then(setSettings); }, []);

  if (!settings) return <div className="h-40 animate-pulse rounded-xl bg-slate-100" />;
  return (
    <div className="space-y-3" data-testid="rs-preview-section">
      <p className="text-sm text-slate-500">معاينة التقرير بالإعدادات العامة المحفوظة حالياً — عدّلها من تبويب «الإعدادات العامة» لترى الأثر فوراً هناك.</p>
      <ReportPreviewMock settings={settings} identity={identity} reportTitle="نموذج تقرير عام" scale={0.75} />
    </div>
  );
}
